import { h, Component, render } from "preact";
import './Visualizer/Config';
import uploadcare from 'uploadcare-widget';
import uploadcareTabEffects from 'uploadcare-widget-tab-effects';
import { VisualizerCanvas, renderCanvas } from './Visualizer/Canvas';
import { VisualizerSections, VisualizerFramePanels, VisualizerPrintPanels } from './Visualizer/Panels';
import { VisualizerFooter, VisualizerHeader, VisualizerErrors, VisualizerModal, VisualizerGettyModal, VisualizerViewToggle, VisualizerATC } from './Visualizer/Elements';

function dimensionValidation(width, height, flow) {
  return function(fileInfo) {
    var imageInfo = fileInfo.originalImageInfo;
    if (imageInfo !== null && flow !== 'frame') {
      if (imageInfo.width < width || imageInfo.height < height) {
        throw new Error('dimensions');
      }
    }
  }
}

function dpiValidation(dpi, flow) {
  return function(fileInfo) {
    var imageInfo = fileInfo.originalImageInfo;
    if (imageInfo !== null && flow !== 'frame') {
      if (imageInfo.dpi && imageInfo.dpi < dpi) {
        throw new Error('dpi');
      }
    }
  }
}

function roundNearEighth(number) { 
  return (Math.round(number * 8) / 8).toFixed(3);
}; 

// Functions and Constructors
export class Visualizer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelData: [],
      data: [],
      // activePanel: '',
      activeFilters: {},
      selectedItem: {},
      selectedItems: [],
      selectedSizes: {
        'width': 8,
        'length': 10
      },
      price: 0,
      finishData: [],
      view: 'frame',
      flow: 'full',
      flowSelected: false,
      imageSelected: false,
      imageDimensions: []
    }
  }

  // Initialize 
  async componentDidMount() {
    const imageToken = await this.getImageToken();
    // Generate Panels
    this.loadData(()=> {
      const paperData = this.getData('printing', 'list');
      const frameData = this.getData('frame', 'list', {}, {}, () => {
        this.setBaseFrame(this.state.baseFrame);
        this.setBaseImage();
        this.frameFilters();
      });
      const mattingData = this.getData('matting', 'list');
      const mountingData = this.getData('mounting', 'list');
      const glazingData = this.getData('glazing', 'list');
    })
  }

  // Helper Functions
  truncate = (str) => {
    return str.length > 90 ? str.substring(0, 90) + "..." : str;
  }

  exit = (url) => {
    let u = typeof url !== 'undefined' && url.indexOf('/pages/visualizer') >= 0 ? Shopify.routes.root : document.referrer
    if (!Object.keys(this.state.selectedItems).length) {window.location=u; return;}

    this.setState({
      exitIntent: true,
      exit: u || Shopify.routes.root
    })
  }

  frameRender = () => {
    this.setState({
      vLoaded: false,
    })
    setTimeout(() => {
      renderCanvas(this, () => {
        this.setState({
          vLoaded: true,
        })
      });
    }, 250)  
  } 

  frameFilters = () => {
    let frames = this.state.panelData && this.state.panelData.frame,
    filterSet = ['color', 'style', 'price', 'width', 'depth', 'material'],
    filters = {};
    for (let filter of filterSet) {
      filters[filter] = frames && frames.map(function (e) { if(e[filter] && e[filter].length) return e[filter]; });
      filters[filter] = Array.from(new Set(filters[filter]));
    }
    this.setState({
      filters: filters
    })
  }

  setImage = (info, type) => {
    let imageSizes = info && (info.download_sizes ? info.download_sizes.filter(e => e.name === 'large' || e.name === 'vector' || e.name === 'medium')[0] : info.crop),
    imageUrl = info && (info.display_sizes ? info.display_sizes[0].uri : info.cdnUrl),
    rotated = info && info.cdnUrlModifiers && (info.cdnUrlModifiers.includes('270') || info.cdnUrlModifiers.includes('90'));
    imageSizes = info && (imageSizes ? imageSizes : info.originalImageInfo);

    if (typeof imageSizes === 'undefined' && type === 'getty') {
      const imageElement = document.querySelector('.visualizer-modal-selected img');
      imageSizes = {};
      imageSizes.width = imageElement && imageElement.clientWidth * 2
      imageSizes.height = imageElement && imageElement.clientHeight * 2
    }

    let ratio = rotated ? imageSizes.height / imageSizes.width : imageSizes.height / imageSizes.width,
    imageWidth = ratio > 1 ? (imageSizes.width < MAXFRAMESIZE[0] * 100 ? imageSizes.width : MAXFRAMESIZE[0] * 100) : (imageSizes.width < MAXFRAMESIZE[1] * 100 ? imageSizes.width : MAXFRAMESIZE[1] * 100),
    imageHeight = imageWidth * ratio;

    const ratioValue = parseFloat(ratio).toFixed(2);
    console.log({'ratiovalue' : ratioValue, 'ratio': ratio})
    let aspectRatio = '';
    if (ratioValue === '1.00') {
      aspectRatio = '1:1';
    } else if (ratioValue === '1.50') {
      aspectRatio = '2:3';
    } else if (ratioValue === '1.25') {
      aspectRatio = '4:5';
    } else if (ratioValue === '1.40') {
      aspectRatio = '5:7';
    } else if (ratioValue === '0.56') {
      aspectRatio = '16:9';
    }


    const imageDimensions = IMAGEDIMENSIONS[aspectRatio];

    let image = info && {
      'url': imageUrl,
      ...(info.originalUrl) && {'originalUrl': info.originalUrl},
      'title': info.title ? info.title : info.name,
      'id': info.id ? info.id : info.uuid,
      ...(type) ? {'type': type} : {'type': 'upload'},
      'height': rotated ? imageWidth : imageHeight,
      'width': rotated ? imageHeight : imageWidth,
    }
    this.setState(previousState => ({
      gLoaded: false,
      imageSelected: false,
      selectedImage: null,
      selectedItems: {
        ...previousState.selectedItems,
        'artwork': (info ? image : null)
      },
      selectedSizes: {
        ...previousState.selectedSizes,
        ...(info) && {'width': roundNearEighth(image.width/100)},
        ...(info) && {'length': roundNearEighth(image.height/100)}
      },
      imageDimensions: imageDimensions
    }), () => {
      this.frameRender();
    });
  }

  getImageToken = async () => {
    let api = new URL(`${SERVICES_URL}/api/images/token`);
    await fetch(`${api}`, {
      method: 'GET'
    })
    .then(res => res.json())
    .then(
      (result) => {
        this.setState({token: result.token})
      },
      (error) => {
        this.setState({token: false});
      }
    )
  }

  searchImage = (e, lm) => {
    let f = document.querySelector('.visualizer-search'),
    s = f && f.elements && f.elements.search.value,
    c = f && f.elements ? f.elements.category.value : false,
    p = lm && f.dataset ? parseFloat(f.dataset.page) + 1 : 1;
    
    lm && f.setAttribute('data-page', p + 1);
    
    let images = this.state.images ? this.state.images : [],
    i = lm ? images : [];

    if (!s) this.setState({gLoaded: true});

    const apiKey = 'vnapevrq2yeetmcru5endkc7';
    const auth = this.state.token;
    const $this = this;

    let search = `&phrase=${s ? s : this.props.visualizerData.getty_term}`,
    style = c ? `&graphical_styles=${c}` : '',
    api = `https://api.gettyimages.com/v3/search/images/creative?fields=istock_collectioncaption,id,orientation,title,preview,artist,download_sizes${style}${search}&page=${p}&page_size=30`;

    $.ajax({
      type:'GET',
      url: api,
      beforeSend: function (request) {
        request.setRequestHeader("Api-Key", apiKey);
        request.setRequestHeader("Authorization", "Bearer " + auth);
      }
    }).done(function(data){
      console.log(data)
      $this.setState({
        images: [...i, ...data.images]
      });
    }).fail(function(data){
      console.log(data)
    });
  }

  uploadImage = (replace = false, type) => {
    let info = !replace && this.state.selectedItems.artwork && this.state.selectedItems.artwork.originalUrl,
    file = info && uploadcare.fileFrom('url', info);
    uploadcare.registerTab('preview', uploadcareTabEffects);
    const dialog = uploadcare.openDialog(
      file, {
        imagesOnly: true,
        multiple: false,
        previewStep: true,
        crop: 'free, 1:1, 2:3, 4:5, 5:7, 16:9',
        validators: [dimensionValidation(1200, 1200, this.state.flow), dpiValidation(240, this.state.flow)]
      }
    );
    dialog.done(res => {
      res.promise().done(info => {
        this.setImage(info);
      });
    });
  }

  // Toggles;

  togglePanel = (e, panelClose = false) => {
    const section = e ? e.target.dataset['section'] : null;
    let preSelectedItem = this.state.selectedItem && this.state.selectedItem[section],
    item = this.state.selectedItems[section];

    let selectedItem = section && item ? {
      [section]: {
        ...(preSelectedItem),
        ...(item.type) && {type: item.type},
        ...(item.sku) && {sku: item.sku},
      }
    } : null,
    selectedItemInfo = item ? {
      [section]: {
        ...(item) && { "title": item.title },
        ...(item && item.image) && {image: item.image},
        ...(item && item.supported) && {supported: item.supported},
        ...(item && item.handle) && {handle: item.handle},
        ...(item && item.depth) && {depth: parseFloat(item.depth)},
        ...(item && item.fWidth) && {fWidth: parseFloat(item.fWidth)},
      }
    } : null;

    this.setState({
      activePanel: section, 
      selectedItem: {...(selectedItem)},
      selectedItemInfo: {...(selectedItemInfo)}
    }, ()=> {
      panelClose && this.setState(
        {activePanel: null, selectedItem: null, selectedItemInfo: null}
      )
      panelClose || section !== 'frame' && this.frameRender();
    });
  }

  toggleState = (state, val) => {
    this.setState({[state]: val})
  }

  // Option Selectors

  loadFlow = (flow) => {
    this.setState({
      ...(flow) && {flow: flow},
      ...(flow) && {flowSelected: true},
    })
  }

  loadData = (callback) => {
    let u = new URLSearchParams(window.location.search),
    fid = u.get('f') ? u.get('f') : false,
    pid = u.get('p') ? u.get('p') : false,
    aid = u.get('a') ? u.get('a') : false,
    flow = u.get('type') ? u.get('type') : false,
    flowSelected = flow || pid ? true : false;

    this.setState(previousState => ({
      // Flow Settings
      flowSelected: flowSelected,
      ...(flow) && {flow: flow},
      ...(flow === 'print' || flow === 'full') && {selections: {'print_border': true}},
      ...(flow !== 'print') && {baseFrame: fid},

      // Pannel Settings
      ...(pid) && {activePanel: pid},
      selectedSizes: {
        ...previousState.selectedSizes,
        ...(flow === 'print') ? {'print_border': 0.5} : {'print_border': 0}
      },
      selectedItems: {
        ...previousState.selectedItems,
        ...(flow === 'print') ? {'print_border': 0.5} : {'print_border': 0}
      }
    }), () => {
      aid && aid === 'g' && this.searchImage();
      aid && aid === 'u' && this.uploadImage();
      callback()
    });
  }

  setBaseImage = () => {
    let url = this.props.visualizerData.img_base;
    if (!url) return;
    
    this.setState({
      imgBase: url.substr(0, url.lastIndexOf('/') + 1)
    })
  }

  setBaseFrame = (fid) => {
    let target = 'frame',
    id = fid ? fid : 'F-MAPLE-WP',
    frame = this.state.panelData[target];

    id = this.state.flow !== 'print' ? id : false;

    for (let frameItem of frame) {
      let frameSupported = frameItem && frameItem.depth && (parseFloat(frameItem.depth) < 1 ? FRAMESUPPORT[0] : FRAMESUPPORT[1]);
      frameItem.supported = frameSupported;
    }

    if (!id) return;
    let f = frame.find(obj => obj.sku == id);

    this.getPrices(f, null, target, ()=> {
      setTimeout(() => {
        this.filterOptions(f, f, target);
      }, 1000)  
    })
  }

  filterFrames = (id, filter, i) => {
    let filters = this.state.activeFilters[filter] ? this.state.activeFilters[filter] : [],
    filterItem = i ? i : id,
    filterTitle = i ? i.title : id,
    remove = filters.includes(filterTitle) || (filters[0] && filters[0].title && filters[0].title === filterTitle);
    filters.map(item => {if (item.title === filterTitle) remove = true;});
    filters = remove ? filters.filter(item => {
      return item.title ? item.title !== filterTitle : item !== filterTitle
    }) : filters;
    !remove && filters.push(filterItem);

    this.setState(previousState => ({
      activeFilters: {
        ...previousState.activeFilters,
        [filter]: filters.length ? filters : null
      }
    }))
  }

  filterOptions = (filter, item, section, frameSupported) => {
    let _sOptions = frameSupported ? frameSupported : (filter && filter.supported),
    _sScope = _sOptions && Object.keys(_sOptions)[0],
    _sData = JSON.parse(JSON.stringify(this.state.panelData)),
    _sPreOptions = this.state.supportedItems ? JSON.parse(JSON.stringify(this.state.supportedItems)) : null;
    
    let _f = _sOptions && _sScope && _sOptions[_sScope],
    _fData = _sData[_sScope],
    _nData = {},
    sizes = this.state.selectedSizes;
    
    // Exisitng Selections
    let _sItems = JSON.parse(JSON.stringify(this.state.selectedItems)),
    _sItem = {[section]: {...filter, ...item}},
    _supported = {},
    _errors = this.state.errors ? this.state.errors : {},
    _sItemsSupported = {..._sOptions, ..._sPreOptions};

    // let _supItems = _f && _f.reduce((o, c) => { if (options && options.hasOwnProperty(c)) {o[c] = options[c]} return o}, {}),
    // _supItem = _f ? this.state.selectedItems[_sScope] && f.find(a =>a.includes(this.state.selectedItems[_sScope].type)) : true;


    // Sizing
    let width = parseFloat(this.state.selectedSizes.width),
    length = parseFloat(this.state.selectedSizes.length),
    fWidth = _sItems['frames'] && _sItems['frames'].fWidth ? _sItems['frames'].fWidth * 2 : 0,
    pWidth = sizes['print_border'] ? parseFloat(sizes['print_border']) * 2 : 0,
    mWidth = sizes['matting'] ? parseFloat(sizes['matting']) * 2 : 0,
    cWidth = parseFloat(width) + fWidth + pWidth + mWidth,
    cLength = parseFloat(length) + fWidth + pWidth + mWidth,
    isPortrait = cLength > cWidth;
    
    // Create PreSelected Support List
    Object.keys(_sData).map((_panel) => {

      // Get Support Options From Item or Passed through Value
      let _sItemSupported = _sItem[_panel] && _sItem[_panel].supported;
      _sItemSupported = _sItemSupported ? _sItemSupported : _sItems[_panel] && _sItems[_panel].supported;
      _sItemSupported = _sItemSupported ? _sItemSupported : _sOptions;

      _sItemsSupported && Object.keys(_sItemsSupported).map((i) => {
        // Compare Previous Array to New array and return only corresponding values
        let _v = _sItemSupported && _sItemSupported[i] ? _sItemsSupported[i].filter(e => _sItemSupported[i].indexOf(e) !== -1) : _supported && _supported[i] ? _supported[i] : _sItemsSupported[i];
        // console.log(_v)
        _supported = {
          ..._supported,
          [i] : _v
        }
      });

      // Set Filter Object
      _sItemsSupported = {
        ..._sItemsSupported,
        ...(_supported) && _supported,
      }
    })

    this.setState(previousState => ({
      supportedItems: {
        ...previousState.supportedItems,
        ..._sItemsSupported,
      }
    }))

    // Filter Items by Section
    Object.keys(_sData).map((_panel) => {
      let _dataFull = _sData[_panel],
      _currPanel = _panel === section,
      // _fData = !_currPanel ? _sPreData[_panel] : _dataFull,
      _fData = _dataFull,
      _fPanel = this.state.flow !== 'print' && Array.isArray(_fData);

      // Filter Frames By Size
      
      // ToDo : Depth
      !_currPanel && _fPanel && (
        _fData = _fData.filter(function(_option) {
          let isWidth = isPortrait ? cWidth <=_option.max_width : cWidth <=_option.max_length,
          isLength = isPortrait ? cLength <= _option.max_length : cLength <= _option.max_width,
          fSupported = item && _option.supported &&_option.supported[section] ?_option.supported[section].includes(item.type) : true;

          return isWidth && isLength && fSupported;
        })
      );

      // Filter Items
      let _fExists = false;
      _errors[_panel] = !_currPanel && _fPanel && !_fData.length ? true : null;
      !_currPanel && _fPanel && _fData.map((_f) => {
        _fExists = _sItems[_panel] && _sItems[_panel].title === _f.title ? true : _fExists;
        _errors[_panel] = !_fExists
      });

      // Filter Items
      !_fPanel && Object.keys(_fData).map((type) => {
        Object.keys(_fData[type].options).map((_o) => {
          let _option = _fData[type].options[_o];
          
          // Filter Items By Size
          let isWidth = _option.max_width ? (isPortrait ? width <=_option.max_width : width <=_option.max_length) : true,
          isLength = _option.max_length ? (isPortrait ? length <=_option.max_length : length <=_option.max_width) : true,
          _sSize = isWidth && isLength,
          _sSupported = ((type === 'type' || type === 'mounting_type' || type === 'glazing_type') && _supported && _supported[_panel]) ? _supported[_panel].includes(_o) : true;
          // console.log(_fData[type].options[_o], _o, _supported[_panel], _sSupported)
          // selected = (!_sSupported || !_sSize) && _sItems[] ? _sItems[dPanel].title === vData[type].options[option].title : false;
          !_sSupported && delete _fData[type].options[_o];
          !_sSize && delete _fData[type].options[_o];
          // console.log(_fData[type].options[_o])

          // Filter Single Tier Items
          !_option.options && _option.supported && Object.keys(_option.supported).map((_s) => {
            let _optionSubSupport = _option.supported[_s],
            _optionSubSupported = _optionSubSupport.filter(function(n) { return _sItemsSupported && _sItemsSupported[_s] && _sItemsSupported[_s].indexOf(n) !== -1;}).length > 0;
            
            let _selectedItem = _sItems[_s] && _sItems[_s].type,
            _selectedItemSupported = _selectedItem ? _optionSubSupport.includes(_selectedItem) : true;
            // console.log(_s, _selectedItem, _optionSubSupport, _selectedItemSupported)
            // console.log(_option, _s, _sItemsSupported[_s], _optionSubSupported)
            (!_optionSubSupported || !_selectedItemSupported) && delete _fData[type].options[_o];
          })

          // Filter Multi Tier Items
          _option.options && Object.keys(_option.options).map((_p) => {
            let _optionSub = _option.options[_p];
          
            _optionSub.supported && Object.keys(_sItemsSupported).length && Object.keys(_optionSub.supported).map((_s) => {
              let _optionSubSupport = _optionSub.supported[_s],
              _optionSubSupported = (_optionSubSupport && _sItemsSupported) ? _optionSubSupport.filter(function(n) { return _sItemsSupported && _sItemsSupported[_s] && _sItemsSupported[_s].indexOf(n) !== -1;}).length > 0 : true;
              // console.log(_o, _s, _sItemsSupported[_s])
            !_optionSubSupported && delete _fData[type].options[_o].options[_p];
            })
          });

        });
      });

      // Set Panel Data
      _nData[_panel] = _fData
    });
    
    // Remove Pre Selected Items

    Object.keys(_errors).length && Object.keys(_errors).map((error) => {
      _errors[error] && _sItems[error] && delete _sItems[error];
      _errors[error] && sizes[error] && delete sizes[error];
    });


    // Set State with Filtered Results
    this.setState(previousState => ({
      data: {
        ..._nData
      },
      selectedItems: {
        ..._sItems,
        ...(!_sItem && !_fPanel && previousState.selectedItems[_sScope]) && {[_sScope]: null}
      },
      ..._errors && {errors: _errors},
      selectedSizes: {
        ...sizes,
        ...(!_sItem && previousState.selectedSizes[_sScope]) && {[_sScope]: -1}
      }
    }));
  }

  selectOption = (e, data, key, multiselect) => {
    // Section and Item Data
    let item = data.option,
    section = data.section,
    sectionType = data.type ? data.type : 'sku',
    preSelectedItem = this.state.selectedItem && this.state.selectedItem[section],
    preSelectedItemInfo = this.state.selectedItemInfo && this.state.selectedItemInfo[section],
    preSelectedSize = this.state.selectedSize && this.state.selectedSize[section];
    
    // Scroll To Top
    let ms = multiselect ? true : false,
    parent = e && e.target.closest('.visualizer-selector-options'),
    t = e && e.target.parentNode.nextSibling && e.target.parentNode.nextSibling.getBoundingClientRect().top - 100;
    parent = window.innerWidth < 992 ? e && e.target.closest('.visualizer-selector-content') : parent;

    let selectedItem = section ? {
      [section]: {
        ...(preSelectedItem),
        ...(sectionType) && {[sectionType]: key},
        ...(item.sku) && {sku: item.sku},
      }
    } : {}, selectedItemInfo = { ...(item) ? {
      [section]: {
        ...(preSelectedItemInfo),
        ...(item && item.handle) && {handle: item.handle},
        ...(item) && { "title": item.title },
        ...(item && item.visualizer_image) && {image: item.visualizer_image},
        ...(item.hex) && {hex: item.hex},
        ...(item.supported) && {supported: item.supported},
        ...(item.handle) && {handle: item.handle},
        ...(item.depth) && {depth: parseFloat(item.depth)},
        ...(item.width_back) && {fWidth: parseFloat(item.width_back)},
      }
    } : null}

    // Matting Size Logic
    let mattingSize = preSelectedSize,
    sMatting = selectedItem['matting'] && selectedItem['matting'].type;

    switch (true) {
      case section === 'matting' && sMatting && sMatting.includes('NO'):
        mattingSize = 0;
        break;
      case section === 'matting' && sMatting && sMatting.includes('MAT'):
        mattingSize = 2;
        break;
      case section === 'matting' && sMatting && sMatting.includes('FLOAT'):
        mattingSize = 1;
        break;
      default:
        break;
    }

    this.setState(previousState => ({
      selectedItem: {
        ...previousState.selectedItem,
        ...(selectedItem)
      },
      selectedSize: {
        ...previousState.selectedSize,
        ...(mattingSize > 0) && {'matting': mattingSize},
      },
      selections: {
        ...previousState.selections,
        ...(mattingSize > 0) && {'matting' : true},
      },
      selectedItemInfo: {
        ...previousState.selectedItemInfo,
        ...(selectedItemInfo)
      }
    }), () =>{
      section === 'frame' && this.frameRender()
    });

    parent && t && ms && parent.scroll({top: parent.scrollTop + t, behavior: 'smooth' });
  }

  addOption = (e, data) => {
    let section = this.state.activePanel,
    info = this.state.selectedItemInfo && this.state.selectedItemInfo[section],
    frameSupported = info && info.depth && (parseFloat(info.depth) < 1 ? FRAMESUPPORT[0] : FRAMESUPPORT[1]),
    item = this.state.selectedItem && this.state.selectedItem[section],
    size = this.state.selectedSize,
    errors = this.state.errors;
    errors && errors[section] && delete errors[section];
    
    // Matting Mounting Logic
    let preMount = section === 'matting' && !this.state.selectedItems['mounting'];
    this.setState(previousState => ({
      vLoaded: false,
      selectedSizes: {
        ...previousState.selectedSizes,
        ...size
      },
      selectedItems: {
        ...previousState.selectedItems,
        ...(size && size["print_border"]) && size,
      },
      selections: {
        ...previousState.selections,
        ...(preMount) && {'mounting' : preMount},
        ...(!preMount) && {[section] : null}
      },
      errors: errors,
      selectedSize: null
    }), ()=> {
      this.getPrices(info, item, section, ()=> {
        if (section === 'matting' && !this.state.selectedItems['mounting']) {
          let items = this.state.panelData['mounting'].mounting_type.options,
          pkey = Object.keys(items)[0],
          item = items[pkey];
          this.getData('mounting', 'calculate', {
            'mounting_type': pkey
          }, {
            ...(item && item.title) && {title: item.title}
          });
        }
        setTimeout(() => {
          this.filterOptions(info, item, section, frameSupported);
        }, 500)  
        this.togglePanel();
      })
    })
  }

  // Sizing Options 
  selectArtSize = (property, e, v = false) => {
    let values = ['length','width'],
    value = v ? v : parseFloat(e.target.value) ? parseFloat(e.target.value) : 0,
    low = MAXFRAMESIZE[0],
    high = MAXFRAMESIZE[1],
    ratioProp = values.filter(e => e !== property),
    ratio = this.state.selectedSizes[ratioProp] ? (this.state.selectedSizes[ratioProp] / this.state.selectedSizes[property]) : 1,
    ratioPropVal = value * ratio,
    info = this.state.selectedItems['artwork'],
    flow = this.state.flow,
    dpi = info.originalImageInfo ? info.originalImageInfo.dpi[0] : 240,
    width = info.width,
    dpiRatio = dpi / 240,
    dpiLimit = width * dpiRatio / 100;

    // Set Minimums
    value = value > 8 ? value : 8;
    value = ratioPropVal > 8 ? value : (ratio > 1 ? 8: 8 / ratio);

    // Set Maximums
    let ratioValid = ratio > 1,
    horizontal = ratio <= 1,
    valueValid = value > low ? value < low / ratio : true;
    value = value > high ? high : value;

    switch (true) {
      case value > high:
        value = ratioValid ? (valueValid ? value : low) : low / ratio;
        value = value > high ? high : value;
        break;
      case value > low:
        value = horizontal ? value : (ratioValid ? low : (valueValid ? value: low / ratio));
        value = horizontal ? value : (value > low ? low : value);
        break;
      default:
        break;
      }
      
    ratioPropVal = value * ratio;
    ratioPropVal = ratioPropVal > high ? high : ratioPropVal;
    value = ratioPropVal / ratio;
    
    if (parseFloat(this.state.selectedSizes[property]) === parseFloat(e.target.value)) return;
    (flow !== 'frame' && value > dpiLimit) ? this.setState({sizeError: true, sizeLimit: dpiLimit}) : this.setState({sizeError: false});
    

    this.setState(previousState => ({
      selectedSizes: {
        ...previousState.selectedSizes,
        [ property ]: roundNearEighth(value),
        [ ratioProp ]:roundNearEighth(value * ratio),
        ratio: ratio
      }
    }), () => {
      this.frameRender();
    });
  }

  // Sizing Options 
  selectCustomArtSize = (dimension) => {
    let ratio = dimension.height / dimension.width;

    this.setState({sizeError: false});

    this.setState(previousState => ({
      selectedSizes: {
        ...previousState.selectedSizes,
        'width': parseFloat(dimension.width).toFixed(2),
        'length': parseFloat(dimension.height).toFixed(2),
        ratio: ratio
      }
    }), () => {
      this.frameRender();
    });
  }

  selectBorderSize = (section, size, e = false) => {
    this.setState(previousState => ({
      selectedSize: {
        ...previousState.selectedSize,
        [`${section}`] : size,
      },
      selections: {
        ...previousState.selections,
        [`${section}`] : e ? false : true,
      }
    }));
  }

  // Pricing and Data Models
  getPrice = (section, info, item) => {
    this.getData(section, 'calculate', {
      ...(info && info.type) && {type: info.type},
      ...(item && item.type) && {type: item.type},
      ...(info && info.option) && {option: info.option},
      ...(item && item.option) && {option: item.option},
      ...(item && item.mounting_type) && {mounting_type: item.mounting_type},
      ...(item && item.glazing_type) && {glazing_type: item.glazing_type},
      ...(info && info.sku) && {sku: info.sku},
      ...(item && item.sku) && {sku: item.sku},
      ...(section === 'matting') && {option: "4-PLY"}
    }, {
      ...(info && info.title) && {title: info.title},
      ...(info && info.visualizer_image) && {image: info.visualizer_image},
      ...(info && info.image) && {image: info.image},
      ...(info && info.hex) && {hex: info.hex},      
      ...(info && info.supported) && {supported: info.supported},      
      ...(info && info.handle) && {handle: info.handle},
      ...(info && info.depth) && {depth: parseFloat(info.depth)},
      ...(info && info.width_back) && {fWidth: parseFloat(info.width_back)},
      ...(info && info.fWidth) && {fWidth: parseFloat(info.fWidth)},
    }, ()=> {
      this.frameRender();
    })
  }

  getPrices = (info, item, section, callback) => {
    let priceItems = this.state.selectedItems;
    section === 'artwork' ? Object.keys(priceItems).map((price) => (
      info = priceItems[price], 
      this.getData('shipping', 'calculate', {}, {title: 'shipping'}),
      this.getPrice(price, info)
    )) : (
      this.getPrice(section, info, item)
    );
    callback && callback();
  }

  updatePrices = () => {
    let priceItems = this.state.selectedItems,
    size = this.state.selectedSizes,
    isPrintPrice = priceItems && priceItems['artwork'],
    priceTotal = isPrintPrice ? 35 : 0,
    price = 0;

    priceTotal = isPrintPrice && (size.width > 16 || size.height > 16) ? 65 : priceTotal;
    priceTotal = isPrintPrice && (size.width > 30 || size.height > 30) ? 95 : priceTotal;

    if(!priceItems) return

    Object.keys(priceItems).map((price) => (
      price = (priceItems[price] && priceItems[price].price) ? priceItems[price].price : 0,
      priceTotal = priceTotal + price
    ));
          
    this.setState({price: priceTotal.toFixed(2)});
  }

  addProduct = (item) => {
    let pid = item && item.shopify_variant_id,
    items = this.state.selectedItems,
    sizes = this.state.selectedSizes, 
    fw = items.frame && items.frame.fWidth ? parseFloat(items.frame.fWidth * 2) : 0,
    pbw = sizes.print_border ? parseFloat(sizes.print_border * 2) : 0,
    mw = sizes.matting ? parseFloat(sizes.matting * 2) : 0,
    data = {'items': [{
      'quantity': 1,
      'id': pid,
      'properties': {
        ...(items.artwork) && {'Artwork': items.artwork.title},
        ...(items.printing) && {'Print Paper': items.printing.title},
        ...(sizes.print_border) && {'Print Border': `${sizes.print_border}"`},
        'Print Dimensions': `${sizes.width}" x ${sizes.length}"'`,
        'Interior Frame Dimensions': `${parseFloat(sizes.width) + mw + pbw}" x ${parseFloat(sizes.length) + mw + pbw}"'`,
        'Exterior Frame Dimensions': `${parseFloat(sizes.width) + mw + pbw + fw}" x ${parseFloat(sizes.length) + mw + pbw + fw}"'`,
        ...(items.frame) && {'Frame': items.frame.title},
        ...(items.frame) && {'_handle': items.frame.handle},
        ...(items.artwork && items.artwork.id && items.artwork.type === 'getty') && {'Getty Image': items.artwork.id},
        ...(items.matting && sizes.matting > -1) && {'Matting': `${sizes.matting}" ${items.matting.title.toLowerCase()} ${items.matting.type.toLowerCase()}`},
        ...(items.mounting) && {'Mounting': items.mounting.title},
        ...(items.glazing) && {'Glazing': `${items.glazing.option.toLowerCase()}`},
      }
    }]};

    console.log(data, items, sizes)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    })
    .then(
      (result) => {
        window.location.href = window.location.origin + "/cart";
      },
      (error) => {
      }
    )
  }

  createProduct = () => {
    let canvas = document.querySelector('.visualizer-frame-canvas'),
    image = canvas.toDataURL("image/jpeg", 0.5).replace('data:image/jpeg;base64,', ''),
    isFrame = this.state.selectedItems.frame ? true : false,
    frameTitle = isFrame ? this.state.selectedItems.frame.title : false,
    title = isFrame ? `Custom Frame - ${frameTitle}` : 'Custom Print';
    
    const body = {
      "title": title,
      "descriptionHtml":"Custom Frame Attributes",
      "price": this.state.price,
      "productType":"Custom Frame",
      "vendor":"SkyFrame",
      "images": [{
        "attachment": image,
        "filename": "frame.png"
      }]
    }
    let api = new URL(`${SERVICES_URL}/api/product/add`);
    fetch(`${api}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    .then(res => res.json())
    .then(
      (result) => {
        this.addProduct(result);
      },
      (error) => {
      }
    )
  }

  getData = (target, method, params, info, callback) => {
    let p = {...params},
    productTitle = info && info.title && info.title.length > 0 && target != 'artwork',
    isProduct = method === 'calculate' ? productTitle : true;
    p.width = this.state.selectedSizes && Math.floor(this.state.selectedSizes.width);
    p.length = this.state.selectedSizes && Math.floor(this.state.selectedSizes.length);
    p.glazing_type && (p.option = p.glazing_type)
    p.glazing_type && delete p.glazing_type;

    let api = new URL(`${SERVICES_URL}/api/${target}/${method}`);
    api.search = new URLSearchParams(p).toString();

    if(!target || !isProduct) this.updatePrices();
    if(!target || !isProduct) { if (callback) callback(); return};

    fetch(`${api}`)
    .then(res => res.json())
    .then(
      (result) => {
        switch (true) {
          case method == 'calculate':
            p.price = result.shipping ? parseFloat(result.shipping.standard) : parseFloat(result.total_price),

            this.setState(previousState => ({
              selectedItems: {
                ...previousState.selectedItems,
                [`${target}`] : {...p, ...info}
              },
              selectedSize: null,
              selectedItem: null,
              selectedItemInfo: null, 
            }), () => {
              this.updatePrices();
              if (callback) callback();
            });
            break;
          default:
            this.setState(previousState => ({
              panelData: {
                ...previousState.panelData,
                [`${target}`]: result
              },
              data: {
                ...previousState.data,
                [`${target}`]: result
              }
            }), () => {
              if (callback) callback();
            });
        }
      },
      (error) => {
        this.setState(previousState => ({
          error,
          selectedItems: {
            ...previousState.selectedItems,
            [`${target}`]: {...p, ...info}
          },
          selectedSize: null,
          selectedItem: null,
          selectedItemInfo: null
        }));
      }
    )
  }
  
  // Render
  render(props) {
    const sections = props.visualizerData.visualizer_sections;
    const room = 'https://cdn.shopify.com/s/files/1/0485/7921/5522/files/visualizer-background-test.jpg?v=1617197415';

    return (
      <div className="visualizer">
        <VisualizerModal {...(props.visualizerData)} $this={this} />
        <VisualizerGettyModal {...(props.visualizerData)} $this={this} />
        <div className="visualizer-container">
          <section className="visualizer-content">
            <div className={`visualizer-room ${this.state.view == "room" && 'selected'}`}>
              <img src={room} alt=""/>
            </div>
            <VisualizerViewToggle {...(this)} />
            <VisualizerCanvas state={this.state}/>
            <VisualizerFooter {...(props)} />
          </section>

          <section className="visualizer-selector">
            <VisualizerHeader {...(props)} $this={this}/>            
            <VisualizerErrors {...this}/>
            <VisualizerSections {...(props.visualizerData)} $this={this} />
            <VisualizerPrintPanels this={this} />
            <VisualizerFramePanels this={this} />
            <VisualizerATC {...(props.visualizerData)} $this={this} />
          </section>
        </div>
      </div>
    )
  }
}

let visualizerDom = document.querySelector('#visualizerContainer');

if (visualizerDom) {
  render(<Visualizer {...({visualizerData})} />, visualizerDom)
}
